import styled from "styled-components";

const DialogActions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1.5rem;
`;

export default DialogActions;
